import Vue from "vue";
import { actions } from "./actions";

const state = Vue.observable({});

export default {
  state,
  actions,
};
